function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f15523;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Procore_Logo_Graphicmark_FC_Black_CMYK");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "PROCORE_GRAPHICMARK",
  "data-name": "PROCORE GRAPHICMARK"
}, /*#__PURE__*/React.createElement("path", {
  d: "M91.6,81.17,84.46,93.49H59.54L47.09,72,59.54,50.51H84.46L91.6,62.83H108V51.74a13.52,13.52,0,0,0-14-14H50a13.52,13.52,0,0,0-14,14V92.26a13.52,13.52,0,0,0,14,14H94a13.52,13.52,0,0,0,14-14V81.17Z",
  transform: "translate(-36 -37.78)"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "29.25 22.57 22.5 34.22 29.25 45.87 42.75 45.87 49.51 34.22 42.75 22.57 29.25 22.57"
}));

var SvgProcore = function SvgProcore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 72 68.44",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProcore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Procore.7d151a92.svg";
export { ForwardRef as ReactComponent };